import type { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const areaGraphDescription: CalculatorDescription = {
  id: CalculatorId.AreaChart,
  title: 'Area Graph Maker',
  metaTitle: 'Online Area Graph Maker - Create Area Charts',
  description: 'Create professional area graphs to visualize cumulative data and stacked relationships over time. Perfect for showing volume changes and proportional trends.',
  metaDescription: 'Make professional area graphs online. Visualize cumulative data and proportions with our free area graph generator. Perfect for showing volume changes over time.',
  howTo: {
    title: 'How to Create an Area Graph',
    steps: [
      'Select your X-axis column (usually time or sequence)',
      'Choose one or more Y-axis columns for data series',
      'Customize area fill opacity and colors',
      'Adjust marker size and appearance',
      'Set title and finalize visualization'
    ],
    graphic: {
      description: 'An echarts area graph with multiple series, customizable fills, and interactive tooltips'
    }
  },
  examples: [
    {
      title: 'Financial Performance',
      description: 'Track financial metrics over time',
      dataDescription: 'Monthly revenue and profit data over a year',
      insights: [
        'Visualize revenue growth trends',
        'Compare profit margins',
        'Identify seasonal patterns',
        'Spot performance gaps'
      ]
    },
    {
      title: 'Market Share Analysis',
      description: 'Compare market share evolution',
      dataDescription: 'Quarterly market share percentages by product',
      insights: [
        'Show market share changes',
        'Track competitive positions',
        'Identify market trends',
        'Analyze share distribution'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.LineChart,
    CalculatorId.StackedBarChart,
    CalculatorId.ColumnChart,
    CalculatorId.XYPlot
  ]
}; 